"use client"

import { createIcon } from "@chakra-ui/react"

export const ArrowBackIcon = createIcon({
  displayName: "ArrowBackIcon",
  viewBox: "0 0 24 24",
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
  },
  path: (
    <>
      <line x1="19" y1="12" x2="5" y2="12" />
      <polyline points="12 19 5 12 12 5" />
    </>
  ),
})

export const ArrowLeftAltIcon = createIcon({
  displayName: "ArrowLeftAltIcon",
  viewBox: "0 0 24 24",
  defaultProps: {
    fill: "currentColor",
  },
  path: (
    <>
      <path d="M12.707 17.293 8.414 13H18v-2H8.414l4.293-4.293-1.414-1.414L4.586 12l6.707 6.707z" />
    </>
  ),
})

export const ArrowLeftIcon = createIcon({
  displayName: "ArrowLeftIcon",
  viewBox: "0 0 24 24",
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
  },
  path: (
    <>
      <path d="m12 19-7-7 7-7" />
      <path d="M19 12H5" />
    </>
  ),
})

export const ArrowNarrowRightIcon = createIcon({
  displayName: "ArrowNarrowRightIcon",
  viewBox: "0 0 24 24",
  defaultProps: {
    fill: "none",
    strokeWidth: "2",
    stroke: "currentColor",
    "aria-hidden": "true",
  },
  path: (
    <>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17 8l4 4m0 0l-4 4m4-4H3"
      />
    </>
  ),
})

export const ArrowRightAltIcon = createIcon({
  displayName: "ArrowRightAltIcon",
  viewBox: "0 0 24 24",
  defaultProps: {
    fill: "currentColor",
  },
  path: (
    <>
      <path d="m11.293 17.293 1.414 1.414L19.414 12l-6.707-6.707-1.414 1.414L15.586 11H6v2h9.586z" />
    </>
  ),
})

export const ArrowRightIcon = createIcon({
  displayName: "ArrowRightIcon",
  viewBox: "0 0 24 24",
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
  },
  path: (
    <>
      <path d="M5 12h14" />
      <path d="m12 5 7 7-7 7" />
    </>
  ),
})

export const ArrowUpIcon = createIcon({
  displayName: "ArrowUpIcon",
  viewBox: "0 0 24 24",
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
  },
  path: (
    <>
      <path d="m5 12 7-7 7 7" />
      <path d="M12 19V5" />
    </>
  ),
})

export const ArrowUpRightIcon = createIcon({
  displayName: "ArrowUpRightIcon",
  viewBox: "0 0 16 16",
  defaultProps: {
    fill: "currentColor",
  },
  path: (
    <>
      <path
        fillRule="evenodd"
        d="M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0z"
      />
    </>
  ),
})

export const ArrowUpRightOutlineIcon = createIcon({
  displayName: "ArrowUpRightOutlineIcon",
  viewBox: "0 0 24 24",
  defaultProps: {
    fill: "currentColor",
  },
  path: (
    <>
      <path d="M18.25 15.5a.75.75 0 0 1-.75-.75V7.56L7.28 17.78a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734L16.44 6.5H9.25a.75.75 0 0 1 0-1.5h9a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75Z" />
    </>
  ),
})

export const ChevronDownIcon = createIcon({
  displayName: "ChevronDownIcon",
  viewBox: "0 0 24 24",
  defaultProps: {
    fill: "currentColor",
  },
  path: (
    <>
      <path d="M16.293 9.293 12 13.586 7.707 9.293l-1.414 1.414L12 16.414l5.707-5.707z" />
    </>
  ),
})

export const ChevronDownOutlineIcon = createIcon({
  displayName: "ChevronDownOutlineIcon",
  viewBox: "0 0 24 24",
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
  },
  path: (
    <>
      <path d="m6 9 6 6 6-6" />
    </>
  ),
})

export const ChevronLeftIcon = createIcon({
  displayName: "ChevronLeftIcon",
  viewBox: "0 0 20 20",
  defaultProps: {
    fill: "currentColor",
    "aria-hidden": "true",
  },
  path: (
    <>
      <path
        fillRule="evenodd"
        d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
        clipRule="evenodd"
      />
    </>
  ),
})

export const ChevronRightIcon = createIcon({
  displayName: "ChevronRightIcon",
  viewBox: "0 0 20 20",
  defaultProps: {
    fill: "currentColor",
    "aria-hidden": "true",
  },
  path: (
    <>
      <path
        fillRule="evenodd"
        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
        clipRule="evenodd"
      />
    </>
  ),
})

export const ChevronRightOutlineIcon = createIcon({
  displayName: "ChevronRightOutlineIcon",
  viewBox: "0 0 24 24",
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
  },
  path: (
    <>
      <path d="m9 18 6-6-6-6" />
    </>
  ),
})
